/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);
    $(window).on('load', documentReady);
    let icon;

    function setup() {
        $('a').click(goToAnchor);
        $('.buttonAsLink').click(function() {
            window.open($(this).attr('data-url'), '_self');
        });
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            let formulaireID = $(event.target).children('.form').attr('id');
            window._mtm = window._mtm || [];
            /* ENVOI NOTIFS MATOMO */
            if(formulaireID === 'devis') {
                window._mtm.push({
                    'event': 'form_submission_contact',
                });
            }else if(formulaireID === 'profil') {
                window._mtm.push({
                    'event': 'form_submission_ficheprofil',
                });
            }
        });
        $('.btn').click(function(e) {
            if($(this).find('span').text().search('contact') !== -1) {
                window._mtm = window._mtm || [];
                window._mtm.push({
                    'event': 'contact_cta',
                });
            }
            if($(this).parent().hasClass('blockfixed')) {
                window._mtm = window._mtm || [];
                window._mtm.push({
                    'event': 'form_submission_qualification',
                });
            }
        });
    }

    function documentReady() {
        initSummary();
        $('.btn-topage, #topPage').click(goTopPage);
        $('.findpro-elem .btn-more').click(showHideProInfos);
        if($('.findpro-map').length !== 0) initProMap();
    }

    // Gérer le sommaire
    function initSummary() {
        $(window).scroll(function() {
            if($(this).scrollTop() >= ($('.footer').offset().top - 800)) {
                $('.summary').addClass('hide');
            }else {
                $('.summary').removeClass('hide');
            }
            
            // Sticker le sommaire
            if($('.summary').length !== 0 && $(this).scrollTop() >= ($('.panel-grid-cell').offset().top - 100)) {
                if(!$('.summary').hasClass('sticky')) $('.summary').addClass('sticky');
            }else {
                $('.summary').removeClass('sticky');
            }
            
            let scrollTop = $(this).scrollTop();
            $('.summary ul li').each(function() {
                var navAncer = $(this).children('a').attr('href');
                var navAncerNext = $(this).next().children('a').attr('href');
                if(navAncerNext !== undefined) {
                    if(scrollTop >= ($(navAncer).offset().top - 165) && scrollTop < ($(navAncerNext).offset().top)) {
                        $('.summary li.current').removeClass('current');
                        $(this).addClass('current');
                        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + navAncer;
                        window.history.pushState({path:newurl},'',newurl);
                    }
                }else if(scrollTop >= ($(navAncer).offset().top - 165)) {
                    $('.summary li.current').removeClass('current');
                    $(this).addClass('current');
                    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + navAncer;
                    window.history.pushState({path:newurl},'',newurl);
                }
            });
        });
        
        $('.summary-title').click(function() {
            if($(this).parent().hasClass('open')) {
                $(this).parent().removeClass('open');
                $(this).parent().removeAttr('style');
            }else {
                $(this).parent().addClass('open');
                $(this).parent().css('max-height', $('.summary-title').innerHeight() + $('.summary-list').innerHeight() + 40 + 'px');
            }
        });
        
        $('.summary-list li a').click(function() {
            $('.summary').removeClass('open');
            $('.summary').removeAttr('style');
            $('.summary li.current').removeClass('current');
            $(this).parent().addClass('current');
        });
    }
    
    // Afficher / cacher les coordonnées des professionnels
    function showHideProInfos() {
        if($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).parent().find('.infos').slideUp(300);
        }else {
            $(this).addClass('open');
            $(this).parent().find('.infos').slideDown(300);
        }
    }
    
    // Carte des professionnels
    function initProMap() {
        let centerCoords = { lat: 46.79311485, lng: 1.6130785000000003 };
        let zoom = 6;
        let zoomLimits = {
            min: 2,
            max: 25
        };
        
        let tileLayer2D = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
        window.layer2D = L.tileLayer(tileLayer2D, {
            minZoom: zoomLimits.min,
            maxZoom: zoomLimits.max,
            reuseTiles: true
        }).on('tileloadstart', function(event) {
            event.tile.setAttribute('loading', 'lazy');
        });
        
        let mapstore = L.map('map', {
            center: centerCoords,
            zoom: zoom,
            minZoom: zoomLimits.min,
            maxZoom: zoomLimits.max,
            touchZoom: true,
            keyboard: false,
            attributionControl: false,
            scrollWheelZoom: false,
            trackResize: true,
            fadeAnimation: true,
            zoomAnimation: true,
            layerControl: false,
            layers: [layer2D]
        });

        let index = 0;
        $('.findpro-map .listpro li').each(function() {
            let latitude = parseFloat($(this).attr('data-latitude'));
            let longitude = parseFloat($(this).attr('data-longitude'));
            let name = $(this).attr('data-name');
            let contact = $(this).attr('data-contact');
            let address = $(this).attr('data-address');
            let deps = $(this).attr('data-deps');
            let email = $(this).attr('data-email');
            let phone = $(this).attr('data-phone');
            let mobile = $(this).attr('data-mobile');
            
            let clusterHtml = '<div id="cluster-' + index + '" class="mapoint"><svg class="icon" role="img" aria-label="Localisation du professionnel"><use xlink:href="' + siteUrl + '/app/themes/promo_serv/images/sprites.svg#icone-pin"></use></svg><div class="clusterinfos"><button class="close"><span class="sr-only">Fermer la fenêtre</span></button><strong>' + name + '</strong><p><span class="adress">' + address +'</span>';
            if(contact !== '') clusterHtml += '<b>Contact :</b> ' + contact +'<br/>';
            if(deps !== '') clusterHtml += '<b>Département(s) d’intervention :</b> ' + deps +'<br/>';
            if(email !== '') clusterHtml += '<b>Email :</b> ' + email +'<br/>';
            if(phone !== '') clusterHtml += '<b>Téléphone :</b> ' + phone +'<br/>';
            if(mobile !== '') clusterHtml += '<b>Mobile :</b> ' + mobile +'<br/>';
            clusterHtml += '</p></div></div>';
            
            let myIcon = L.divIcon({
                className: 'cluster cluster-' + index,
                iconSize: [40, 40],
                iconAnchor: [20, 40],
                html: clusterHtml
            });
            
            let marker = L.marker([latitude, longitude], {icon: myIcon}).on('click', showHideClusterInfos).addTo(mapstore);
            index++;
        });
    }

    // Fonction qui permet d'afficher les infos d'un pro sur la carte, au click sur un cluster
    function showHideClusterInfos() {
        icon = this._icon.classList[2];
        if($('#map .' + icon).find('.clusterinfos').hasClass('show')) {
            $('#map .' + icon).find('.clusterinfos').removeClass('show');
            setTimeout(function() { $('#map .' + icon).removeClass('active'); }, 300);
        }else {
            $('#map .clusterinfos').removeClass('show');
            setTimeout(function() {
                $('#map .leaflet-marker-icon.active').removeClass('active');
                $('#map .' + icon).addClass('active');
            }, 300);
            $('#map .' + icon).find('.clusterinfos').addClass('show');
        }
    }

    // Animation pour aller aux ancres
    function goToAnchor(e) {
        var url = $(this).attr('href');
        var target = $(this).attr('target');
        if(url && url !== '#' && url.indexOf('#') !== -1 && target !=='_blank') {
            var id = url.split('#')[1];
            if(id.indexOf('/') === -1 && id !== '' && $('#'+id).length !== 0) {
                e.preventDefault();
                var offset = $('#'+id).offset().top - 150;
                $('html, body').animate({scrollTop: offset}, 1000);
            }
        }
    }

    // Retour en haut de page
    function goTopPage() {
        $('html, body').animate({scrollTop: 0}, 1500);
    }
